import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainLayout from "../../../layouts/main/main_layout";
import { ArrowBackRounded, Download, DownloadOutlined, QuizRounded } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import XlsIcon from "../../../assets/xls_icon.svg";
import {
  downloadAudioVdoOfSubmittedChoice,
  downloadSubmittedResponse,
  getSubmitteSurveyordDetails,
} from "../../../services/surveyor/surveyor";
import { useQuery } from "react-query";
import { SubmittedChoiceDetails } from "../model/submitted_choice_details";
import { downloadFromBlob } from "../../../utils/utils";
import { black, greenLight, greyEnabled, purple, purpleLight } from "../../../theme/colors";
import SurveyMedia from "../../../components/survey_media/survey_media";
import ReactPlayer from "react-player";
import Loading from "../../../components/loading/loading";
import { useFeedback } from "../../../providers/feedback/feeedback";

export default function SubmittedResponseDetails() {
  const [currentTab, setCurrentTab] = React.useState(0);
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const [image, setImage] = useState("");
  const [audioUrl, setAudioUrl] = useState(null);
  const [src, setSrc] = useState("")
  const { showSnackbar } = useFeedback();


  function listItem({
    title,
    value,
  }: {
    title: string;
    value: any;
  }): JSX.Element {
    return (
      <Box style={{ overflow: "hidden" }}>
        <Typography variant="body2" sx={{ color: black, fontWeight: 600, letterSpacing: 0.2 }}>
          {title}
        </Typography>
        <Typography sx={{ color: black, fontWeight: 500, mt: 0.25 }} textOverflow="ellipsis" overflow="hidden">
          {value || "-"}
        </Typography>
      </Box>
    );
  }

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
  };

  const { data: surveyResponseDetails, isLoading } =
    useQuery<SubmittedChoiceDetails>(["surveyResponseDetails", id, state?.id], async () => {
      let response = await getSubmitteSurveyordDetails({
        choiceId: +state.id!,
        submittedId: +id!,
      });
      return response?.data?.data?.data;
    });

  const downloadSubmittedResponseApiCall = () => {
    setDownloading(true);
    downloadSubmittedResponse({
      choiceId: +state.id!,
      submittedId: +id!,
      format: "excel",
    })
      .then((res) => {
        let extension = ".xlsx";
        downloadFromBlob(res, extension);
      })
      .catch((e) => { })
      .finally(() => setDownloading(false));
  };

  const renderCompoBasedOnTheTab = () => {
    switch (currentTab) {
      case 0:
        return personalDetails();
      case 1:
        return locationDetails();
      case 2:
        return otherDetails();
      case 3:
        return durableDetails();
      case 4:
        return identificationOfRespondence();
    }
  };

  const handlePlay = () => {
    const audio = new Audio(audioUrl!);

    audio.play();
  };

  function personalDetails() {
    return (
      <>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "UID",
            value: surveyResponseDetails?.surveyorDetails?.id,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Full Name",
            value: surveyResponseDetails?.userDetails?.name,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Date of Birth",
            value: new Date(surveyResponseDetails?.userDetails?.dob || '').toLocaleDateString('en-GB'),
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Gender",
            value: surveyResponseDetails?.userDetails?.gender,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Marital Status  (Optional)",
            value: surveyResponseDetails?.userDetails?.maritalStatus,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Email  (Optional)",
            value: surveyResponseDetails?.userDetails?.email,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Mobile Numer",
            value: surveyResponseDetails?.userDetails?.mobileNumber,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}></Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Income",
            value: surveyResponseDetails?.userDetails?.familyIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Subscribed to Newsletter",
            value: "",
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Newsletter Email ID",
            value: "",
          })}
        </Grid>
      </>
    );
  }
  function locationDetails() {
    return (
      <>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "House/Flat/Room No. (Optional)",
            value: surveyResponseDetails?.locationDetails?.addressLine1,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Building/Chawl Name/No. (Optional)",
            value: surveyResponseDetails?.locationDetails?.addressLine2,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Street/Road No./Name (Optional)",
            value: surveyResponseDetails?.locationDetails?.addressLine3,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Locality/Area",
            value: surveyResponseDetails?.locationDetails?.area,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Landmark (Optional)",
            value: surveyResponseDetails?.locationDetails?.landmark,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "State",
            value: surveyResponseDetails?.locationDetails?.state,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "District",
            value: surveyResponseDetails?.locationDetails?.district,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "PIN Code",
            value: surveyResponseDetails?.locationDetails?.pincode,
          })}
        </Grid>
      </>
    );
  }

  function otherDetails() {
    return (
      <>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Educational Qualification",
            value: surveyResponseDetails?.otherDetails?.education,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Working Status",
            value: surveyResponseDetails?.otherDetails?.workingStatus,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Occupation",
            value: surveyResponseDetails?.otherDetails?.occupation,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Type",
            value: surveyResponseDetails?.otherDetails?.familtyType,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Ownership of House",
            value: surveyResponseDetails?.otherDetails?.houseOwnership,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Personal Income",
            value: surveyResponseDetails?.otherDetails?.personalIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Income",
            value: surveyResponseDetails?.otherDetails?.familyIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}></Grid>
      </>
    );
  }

  function durableDetails() {
    return (
      <Grid item md={6} lg={6} sm={12} xs={12}>
        <Typography color="primary.main">{"Durable details"}</Typography>
        {surveyResponseDetails?.durableDetails?.length === 0 ? (
          <Typography>{"-"}</Typography>
        ) : (
          surveyResponseDetails?.durableDetails?.map((durableItems) => (
            <Typography>{durableItems}</Typography>
          ))
        )}
      </Grid>
    );
  }

  function downloadAudioVideo(format: string, extension: string = '.xlsx', audioDownload = false) {
    downloadAudioVdoOfSubmittedChoice({
      submittedId: +id!,
      type: format,
      choiceId: +state.id!,
    })
      .then((res) => {
        if (format === "image") {
          var urlCreator = window.URL || window.webkitURL;
          let imageUrl = urlCreator.createObjectURL(res.data);
          setImage(imageUrl);
        } else {
          if (audioDownload) {
            downloadFromBlob(res, extension);
          }
          setAudioUrl(res?.data);
          const audioBlob = new Blob([res.data], { type: 'video/mp4' });
          const audioUrl = URL.createObjectURL(audioBlob);
          setSrc(audioUrl)
        }
      })
      .catch((e) => {
        const label = format === "image" ? "image" : format === "video" ? "video" : "audio";
        showSnackbar(e?.response?.data?.error?.message || `Failed to load respondent ${label}.`);
      });
  }

  useEffect(() => {
    if (!surveyResponseDetails?.otherDetails) return;
    setImage("");
    setSrc("");
    if (surveyResponseDetails.otherDetails.respondentImage) {
      downloadAudioVideo("image");
    }
    if (surveyResponseDetails.otherDetails.audioRecording) {
      downloadAudioVideo("audio", '.mp4', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyResponseDetails]);

  function identificationOfRespondence() {
    return (
      <Grid item md={12} lg={12} sm={12} xs={12}>
        {surveyResponseDetails?.otherDetails?.respondentImage && (
          <Box>
            <Typography color="primary.main" mb={1}>
              {"Respondent image"}
            </Typography>
            <img src={image} alt="" height={160} width={312} />
          </Box>
        )}
        <Grid container spacing={3}>
          {surveyResponseDetails?.otherDetails?.audioRecording && (
            <>
              <Grid item md={6} lg={6} sm={12} >
                <Typography color="primary.main">{"Respondent Audio"}</Typography>

                <Box
                  display={"flex"}
                  mt={1}
                  sx={{
                    border: "1px solid #F5E6F5",
                    borderRadius: 2,
                    p: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    downloadAudioVideo("audio", ".mp4", true);
                  }}
                  width="100%"
                >
                  <Typography flex={1}>{"Audio"}</Typography>
                  <DownloadOutlined
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      color: "primary.main",
                      alignItems: "flex-end",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item md={6} lg={6} sm={12}>
                {src &&
                  <video controls height={90} width={330} >
                    <source src={src!} type="audio/mp4" />
                  </video>}
              </Grid>
            </>
          )}


          {surveyResponseDetails?.otherDetails?.videoRecording && (
            <Grid item md={6} lg={6} sm={12}>
              <Typography color="primary.main">{"Respondent Video"}</Typography>
              <Box
                display={"flex"}
                mt={1}
                sx={{
                  border: "1px solid #F5E6F5",
                  borderRadius: 2,
                  p: 2,
                  cursor: "pointer",
                }}
                onClick={() => {
                  downloadAudioVideo("video", '.mp4', true);
                }}
                width="100%"
              >
                <Typography flex={1}>{"Video"}</Typography>
                <DownloadOutlined
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    color: "primary.main",
                    alignItems: "flex-end",
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }

  function answerType({ type, response }: { type: string; response: any }) {
    switch (type) {
      case null:
        return (
          (typeof response === "string" || typeof response === "boolean") && (
            <Box>
              <Typography>{response?.toString()}</Typography>
            </Box>
          )
        );

      case "text":
      case "comment":
      case "radiogroup":
      case "rating":
      case "checkbox":
      case "dropdown":
      case "tagbox":
      case "ranking":
      case "boolean":
      case "imagepicker":
        return (
          <Box>
            <Typography>{response?.toString()}</Typography>
          </Box>
        );
      case "multipletext":
        const objectValuesArray = Object.values(response);
        return (
          <Box>
            {objectValuesArray.map((value: any, index: any) => (
              <Typography>{value}</Typography>
            ))}
          </Box>
        );
      case "matrix":
        return (
          <Box>
            {Object.keys(response).map((qsn) => {
              return (
                <Typography>{`${qsn} : ${response[`${qsn}`]}`}</Typography>
              );
            })}
            <Typography></Typography>
          </Box>
        );
      case "matrixdropdown":
        return (
          <Box>
            {Object.keys(response).map((qsn) => {
              return (
                <Box display={"flex"}>
                  <Typography>{`${qsn} : `}</Typography>
                  {Object.keys(response[qsn]).map((item) => (
                    <Typography mx={1}>
                      {` ${item} -> ${response[qsn][item]}`}
                    </Typography>
                  ))}
                </Box>
              );
            })}
            <Typography></Typography>
          </Box>
        );
      case "matrixdynamic":
        return (
          <Box>
            {response.map((item: any) => {
              return Object.keys(item).map((qsnKey: any) => {
                return (
                  <Typography>{`${qsnKey} : ${item[`${qsnKey}`]}`}</Typography>
                );
              });
            })}
            <Typography></Typography>
          </Box>
        );
      case "file":
        return (
          <Box>
            {response.map((item: any) => {
              // Backend now returns { url, name, mimeType, fileType } (a
              // signed GCS URL) per surveyor_services.js, not { content, type }.
              const mediaType =
                item.mimeType || (item.fileType === "gif" ? "image/gif" : item.fileType);
              return (
                <Box py={1}>
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2">{item.name}</Typography>
                    &nbsp;&nbsp;{" "}
                    <a href={item.url} download={item.name} style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
                      <IconButton size="small">
                        <Download />
                      </IconButton>
                    </a>
                  </Box>

                  {item.url && item.fileType !== "file" && (
                    <SurveyMedia url={item.url} type={mediaType} />
                  )}
                </Box>
              );
            })}
            <Typography></Typography>
          </Box>
        );

    }
  }

  return (
    <MainLayout>
      <Grid container spacing={3} mt={2}>
        <Grid item md={8} lg={8} sm={12} xs={12}>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: purpleLight,
                  flexShrink: 0,
                }}
              >
                <QuizRounded sx={{ color: purple, fontSize: 22 }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700} color={black}>
                  Survey Response Details
                </Typography>
                <Typography variant="body2" color={greyEnabled}>
                  {surveyResponseDetails?.userDetails?.name || "View survey response submission details."}
                </Typography>
              </Box>
            </Box>
          </Box>

          {isLoading ? (
            <Card
              elevation={0}
              sx={{ display: "flex", minHeight: 500, justifyContent: "center", alignItems: "center", borderRadius: 3, border: "1px solid #ECECEC" }}
            >
              <Box display="flex" justifyContent="center" py={8}>
                <Loading />
              </Box>
            </Card>
          ) : (
          <Card elevation={0} sx={{ width: "100%", borderRadius: 3, border: "1px solid #ECECEC" }}>
            <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
              <Grid container spacing={3} mt={1}>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                  {listItem({
                    title: "Choice taken by",
                    value: surveyResponseDetails?.surveyorDetails?.name,
                  })}
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                  {listItem({
                    title: "Location",
                    value: `${surveyResponseDetails?.locationDetails.lat},${surveyResponseDetails?.locationDetails.lon}`,
                  })}
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                  <Box>
                    <Typography color="primary.main">
                      {"Choice Name"}
                    </Typography>
                    <Button
                      sx={{ mx: 0, px: 0 }}
                      onClick={() =>
                        navigate(
                          `/surveys/viewSurveys/${surveyResponseDetails?.choiceDetails?.choiceId}`
                        )
                      }
                    >
                      <Typography
                        color="primary.main"
                        fontWeight={"600"}
                        sx={{
                          borderBottom: "3px solid #990099",
                          width: "fit-content",
                        }}
                      >
                        {surveyResponseDetails?.choiceDetails.choiceName}
                      </Typography>
                    </Button>
                  </Box>
                </Grid>
                {surveyResponseDetails?.locationDetails.lat &&
                  surveyResponseDetails?.locationDetails.lon && (
                    <Grid item md={12} lg={12} sm={12} xs={12}>
                      <Box
                        height={160}
                        mt={1}
                        sx={{ borderRadius: 4, overflow: "hidden" }}
                      >
                        <iframe
                          title="map"
                          width="100%"
                          height="100%"
                          frameBorder={0}
                          src={`https://maps.google.com/maps?q=${surveyResponseDetails?.locationDetails.lat},${surveyResponseDetails?.locationDetails.lon}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                        />
                      </Box>
                    </Grid>
                  )}
                <Box mt={2} mb={2}>
                  <Divider />
                </Box>
                <Typography
                  variant="body1"
                  fontWeight="600"
                  paddingLeft={1}
                  ml={2}
                  mt={3}
                >
                  Respondent Details
                </Typography>
              </Grid>

              <Tabs
                value={currentTab}
                onChange={handleChange}
                sx={{
                  "MuiTabs-root css-112qdbf-MuiTabs-root": {
                    borderColor: "#F5E6F5",
                    overflow: 'auto'
                  },
                  "MuiTabs-flexContainer css-k008qs": {
                    overflow: 'scroll'
                  },
                  ".css-heg063-MuiTabs-flexContainer": {
                    overflow: 'auto'
                  },
                  mt: 2,
                }}
              >
                <Tab
                  label="Personal details"
                  sx={{
                    textTransform: "capitalize",
                    color: black,
                  }}
                />
                <Tab
                  label="Location details"
                  sx={{ textTransform: "capitalize", color: black }}
                />
                <Tab
                  label="Other details"
                  sx={{ textTransform: "capitalize", color: black }}
                />
                <Tab
                  label="Durable details"
                  sx={{ textTransform: "capitalize", color: black }}
                />
                <Tab
                  label="Identification of respodence"
                  sx={{ textTransform: "capitalize", color: black }}
                />
              </Tabs>
              <Box mt={3}>
                <Grid container spacing={3} mt={1}>
                  {renderCompoBasedOnTheTab()}
                </Grid>
              </Box>

              <Box mt={2}>
                <Typography variant="subtitle1" fontWeight={"600"}>
                  Question and Answers
                </Typography>
              </Box>
              <Box>
                <Card
                  elevation={0}
                  sx={{
                    height: 350,
                    overflowY: "scroll",
                    p: 2,
                    borderRadius: 3,
                    border: "1px solid #ECECEC",

                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#F5E6F5",
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#DFB0DF",
                      borderRadius: "6px",
                    },
                  }}
                >
                  {surveyResponseDetails?.choiceDetails?.answerList?.map(
                    (items, index: any) => {
                      return (
                        items.response && (
                          <Box mb={1}>
                            <Typography color="#91278F" variant="body2">
                              {index + 1}. {items?.question}
                            </Typography>
                            {answerType({
                              type: items.questionType,
                              response: items.response,
                            })}
                          </Box>
                        )
                      );
                    }
                  )}
                </Card>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  mt={3}
                  gap={1.5}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Button
                    onClick={() => navigate(-1)}
                    variant="outlined"
                    startIcon={<ArrowBackRounded sx={{ height: 18, width: 18 }} />}
                    sx={{
                      borderColor: purple,
                      color: purple,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      "&:hover": { borderColor: purple, bgcolor: purpleLight },
                    }}
                  >
                    Back To Responses
                  </Button>
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Generate Report:
                    </Typography>
                    <Tooltip title="Download as XLS">
                      <span>
                        <IconButton
                          disabled={downloading}
                          onClick={downloadSubmittedResponseApiCall}
                          sx={{ bgcolor: greenLight, borderRadius: 2, ml: 1.5, height: 36, width: 36 }}
                        >
                          {downloading ? (
                            <CircularProgress size={18} sx={{ color: purple }} />
                          ) : (
                            <img src={XlsIcon} alt="" style={{ height: 20, width: 20 }} />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
          )}
        </Grid>
      </Grid>
    </MainLayout >
  );
}
